
{
  "fr": {
    "ProductPageSlider": {
      "from": "À partir de",
      "unit": "unités !"
    }
  }
}
